import { useState } from "react";
import { Switch } from "@headlessui/react";
import Container from "components/Container";
import Button from "components/Button";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

const heroImage = require("../../../images/hero.jpeg");
const flagImage = require("../../../images/flag.png");

export default function Hero() {
  const [enabled, setEnabled] = useState(true);

  return (
    <Container>
      <div className="grid grid-cols-2 items-center py-8">
        <div>
          <h1 className="font-bold text-black text-2xl leading-6 lg:text-4xl mb-6 lg:leading-10">
            Browse for <br />
            Opportunities in Asia
          </h1>
          <div className="flex gap-4">
            <input
              type="text"
              className="border rounded-lg border-slate-300 w-full max-w-60"
              placeholder="Enter Keywords"
            />
            <Button className={'bg-black'}>Search <MagnifyingGlassIcon className="size-4" /></Button>
          </div>
        </div>
        <img
          src="/hero.jpg"
          className="max-w-full w-[800px]"
          alt="Browse for Opportunities in Asia"
        />
      </div>
    </Container>
  );
}
